import {Bell, Boxes, Building2, FileText, Folders, InfoIcon, LayoutDashboard, Users} from "lucide-react";
import {NavItem} from "@/routes/navigation";
import {ROUTES} from "@/constants/routes.constants";

export const administratorNavItems: NavItem[] = [
    {
        name: 'Πίνακας Ελέγχου',
        icon: LayoutDashboard,
        href: '/'
    },
    {
        name: 'Αιτήματα',
        icon: FileText,
        children: [
            { name: 'Όλα τα Αιτήματα', href: '/tickets' },
            { name: 'Δημιουργία Αιτήματος', href: '/tickets/new' },
            { name: 'Κατηγορίες', href: '/tickets/categories' },
        ]
    },
    {
        name: 'Υποθέσεις',
        icon: Folders,
        children: [
            { name: 'Όλες οι Υποθέσεις', href: '/cases' },
            { name: 'Δημιουργία Υπόθεσης', href: '/cases/new' }
        ]
    },
    {
        name: 'Χρήστες',
        icon: Users,
        children: [
            { name: 'Όλοι οι Χρήστες', href: '/users' },
            { name: 'Προσθήκη Χρήστη', href: '/users/new' }
        ]
    },
    {
        name: 'Εταιρίες',
        icon: Building2,
        children: [
            { name: 'Όλες οι Εταιρίες', href: '/companies' },
            { name: 'Προσθήκη Εταιρίας', href: '/companies/new' }
        ]
    },
    {
        name: 'Προϊόντα',
        icon: Boxes,
        children: [
            { name: 'Όλα τα Προϊόντα', href: '/products' },
            { name: 'Προσθήκη Προϊόντος', href: '/products/new' },
            { name: 'Τύποι Προϊόντων', href: '/products/types' }
        ]
    },
    /*{
        name: 'Αναφορές',
        icon: BarChart3,
        children: [
            { name: 'Αναφορά Αιτημάτων', href: '/reports/tickets' },
            { name: 'Αναφορά SLA', href: '/reports/sla' }
        ]
    },*/
    {
        name: 'Πληροφορίες',
        icon: InfoIcon,
        children: [
            { name: 'Επίπεδα Προτεραιότητας', href: ROUTES.PRIORITIES.LIST },
            { name: 'Καταστάσεις', href: ROUTES.STATUS.LIST }
        ]
    },
    {
        name: 'Ειδοποιήσεις',
        icon: Bell,
        href: '/notifications'
    },
    /*{
        name: 'Dashboard',
        icon: LayoutDashboard,
        children: [
            { name: 'Helpdesk', href: '/dashboard/helpdesk' },
            { name: 'Manager', href: '/dashboard/manager' },
            { name: 'Agent', href: '/dashboard/agent' },
            { name: 'Client Admin', href: '/dashboard/client-administrator' },
            { name: 'Client Manager', href: '/dashboard/client-manager' },
            { name: 'Client Employee', href: '/dashboard/client-employee' },
        ]
    }*/
];

